import React, { ChangeEvent, KeyboardEvent, useEffect, useRef, useState } from 'react'

import { EditableInputProps } from './editableInput.types'
import * as S from './editableInput.styles'

export const EditableInput = ({ initialValue, onSave }: EditableInputProps) => {
    const [newTitle, setNewTitle] = useState(initialValue)

    const inputRef = useRef<HTMLInputElement>(null)

    useEffect(() => {
        if (inputRef.current) {
            inputRef.current.select()
        }
    }, [])

    const handleInputChange = (event: ChangeEvent<HTMLInputElement>) => {
        setNewTitle(event.target.value)
    }

    const handleInputBlur = () => {
        onSave(newTitle)
    }

    const handleInputKeyUp = (event: KeyboardEvent<HTMLInputElement>) => {
        if (event.key === 'Enter') {
            handleInputBlur()
        }
    }

    return (
        <S.Input
            ref={inputRef}
            type="text"
            aria-label="Survey name"
            value={newTitle}
            onChange={handleInputChange}
            onBlur={handleInputBlur}
            onKeyUp={handleInputKeyUp}
        />
    )
}
